import config from 'constants/config'

export const getIsMultiTravellerEnabled = (_businessAccount: App.BusinessTraveller.CurrentBusinessAccount) => {
  // This function and corresponding feature flag is targeted to be removed on completion of OPERX-490
  return config.BUSINESS_TRAVELLER_MULTI_TRAVELLER_ENABLED
}
